import { getListaHikari } from "@/services/report";
import ListaPlataforma, { ColunaLista } from "../ListasPlataformas/ListaPlataforma";

interface ListaHikariItem {
  unidade: string;
  nome: string;
  email: string;
  // Específicas ativas em ordem alfabética, separadas por "; " — montado pelo backend.
  especificas: string;
}

const colunas: ColunaLista<ListaHikariItem>[] = [
  { titulo: "UNIDADE", campo: "unidade", width: 160 },
  { titulo: "NOME", campo: "nome", width: 280 },
  { titulo: "EMAIL", campo: "email", width: 260 },
  { titulo: "ESPECÍFICAS", campo: "especificas", width: 480 },
];

export default function ListaHikari() {
  return (
    <ListaPlataforma<ListaHikariItem>
      titulo="Lista Hikari"
      nomeArquivo="lista_hikari"
      nomePlanilha="Lista Hikari"
      buscar={getListaHikari}
      colunas={colunas}
    />
  );
}
